module.exports = __webpack_public_path__ + "static/media/PracticeOption.a85c0ef8.svg";